import styled from 'styled-components';

const WidgetWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  position: relative;
  background-color: ${({ theme }) => theme.configs.widget.bgColor};
`;

export default WidgetWrapper;
